/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * email_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Coarse sync state for an inbox, used to render a one-line hint in the
multi-inbox settings list. Derived from the link's `is_sync_active` flag, its
reauth health, and its most recent backfill job.
 */
export type SyncStatus = (typeof SyncStatus)[keyof typeof SyncStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SyncStatus = {
  SYNCING: 'SYNCING',
  UP_TO_DATE: 'UP_TO_DATE',
  ERROR: 'ERROR',
  NEEDS_REAUTH: 'NEEDS_REAUTH',
  INACTIVE: 'INACTIVE',
} as const;
